<template>
  <div class="resources--root">
      <h2 class="ui header">
        My Submitted Organization Profiles
      </h2>
    <table class="ui compact celled definition table">
      <thead class="full-width">
        <tr>
          <th>Organization</th>
          <th>Country</th>
          <th>Sectors</th>
          <th>Countries of work</th>
          <th>Submitted At</th>
          <th>Statues</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(resource, idx) in orgs" :key="idx">
          <td>
            <h4 class="ui image header">
                <img :src="resource.logo" class="ui mini rounded image">
                <div class="content">
                  <router-link :to="'/dashboard/orgs/' + resource.ID">
                    {{ resource.post_title }}
                  </router-link>
                <div class="sub header">{{ resource.contact_person.name }}</div>
                <div>
                  <a :href="resource.permalink" target="_blank" v-show="resource.post_status === 'publish'" class="view--on--website--btn">
                View <i class="external alternate icon"></i>
                </a>
                </div>
              </div>
            </h4>
          </td>
          <td>
            <sui-flag :name="resource.country" />
          </td>
          <td>
            <span v-for="(sect, i) in resource.sectors" :key="i">
              {{ sect.name }} <span v-if="i < resource.sectors.length - 1">,</span>
            </span>
          </td>
          <td>
            <sui-flag v-for="(cow, i) in resource.countries_of_work" :key="i" :name="cow" />
          </td>
          <td>{{ resource.post_date }}</td>
          <td class="negative" v-show="resource.post_status === 'rejected'"><i class="icon close"></i> Rejected</td>
          <td class="positive" v-show="resource.post_status === 'publish'"><i class="icon checkmark"></i> Approved</td>
          <td class="warning" v-show="resource.post_status === 'pending'"><i class="attention icon"></i> Pending Approval
          </td>
          <td class="collapsing">
            <div class="ui icon buttons">
              <button @click="moveToEdit(resource)" class="positive ui small button sc--tooltip" data-content="Edit" data-variation="mini">Edit <i class="edit icon"></i></button>
            </div>
          </td>
        </tr>
        <tr v-if="orgs.length === 0">
            <p class="warning message sc--no--resources--msg">
              No Organizations , Add Some
            </p>
        </tr>
      </tbody>
      <tfoot class="full-width">
        <tr>
          <th></th>
          <th colspan="6">
            <router-link class="ui right floated small labeled icon button sc--btn add--resource--btn" to="/dashboard/add-org">
              <i class="plus icon"></i> Add Organization
            </router-link>
          </th>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
export default {
  name: 'ResourcesPage',
  data() {
    return {
      resources: [],
      orgs: [],
    };
  },
  created() {
    this.fetchOrgs();
  },
  methods: {
    moveToEdit(res) {
      localStorage.setItem('cn_t_nt', res.post_content);
      this.$router.push('/dashboard/orgs/' + res.ID + '/edit');
    },
    async fetchOrgs() {
      try {
        const response = await fetch('/wp-json/custom/v1/my-org-profiles?k__sjnb__sdfjn0547=' + localStorage.getItem('sjdifjsckdsjfosdf54520zzz') + '', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          },
        });

        const responseData = await response.json();

        if (response.ok && responseData.success) {
          this.orgs = responseData.orgs;
        } else {
          console.error('Failed to fetch orgs:', responseData);
        }
      } catch (error) {
        console.error('An error occurred:', error);
      }
    },
  },
}
</script>

<style scoped lang="sass">
  .sc--btn
    min-width: auto
    color: #fff !important
    background: #D0AE18 !important

  .view--on--website--btn
    font-size: 12px
    font-weight: normal

  tr:hover
    background: #f9fafb
</style>